import type { ItemUserModel } from '@shared/models/itemUser.model';

export const ownerCheckedUsersArr = (
  users: ItemUserModel[],
  owner: ItemUserModel,
  isContainOwnerInUsers: boolean,
): ItemUserModel[] => {
  return isContainOwnerInUsers
    ? users.findIndex((item) => item?.id === owner.id) >= 0
      ? users
      : [owner, ...users]
    : users.filter((item: { id: number }) => item?.id !== owner?.id);
};
